import { SubCategoryCode } from 'config-request/src/interfaces/feature-list';
export var MultipleKeyName;
(function (MultipleKeyName) {
    MultipleKeyName["exteriorCustom"] = "exteriorCustom";
    MultipleKeyName["interiorCustom"] = "interiorCustom";
    MultipleKeyName["optionalConfig"] = "optionalConfig";
    MultipleKeyName["additionalConfig"] = "additionalConfig";
})(MultipleKeyName || (MultipleKeyName = {}));
export const SubCodeMap = {
    [SubCategoryCode.ExteriorCustom]: MultipleKeyName.exteriorCustom,
    [SubCategoryCode.CockpitCustom]: MultipleKeyName.interiorCustom,
    [SubCategoryCode.SubOptional]: MultipleKeyName.optionalConfig,
};
